import PropTypes from 'prop-types'

import { noop } from 'utils'
import Transition from 'components/animation/Transition'

const QUARTER_SECOND = 250

const Slide = ({
  inline,
  className = '',
  slideDown = QUARTER_SECOND,
  slideUp = QUARTER_SECOND,
  duration,
  on,
  style,
  onCollapse = noop,
  onExpand = noop,
  preserveElement = false,
  children,
}) => (
  <Transition
    cssProperties={{
      height: [0, 'auto'],
    }}
    measure={element => ({ height: element.clientHeight })}
    style={{ overflow: 'hidden', ...style }}
    inline={inline}
    on={on}
    transitionIn={duration || slideDown}
    transitionOut={duration || slideUp}
    preserveElement={preserveElement}
    onTransitionIn={onExpand}
    onTransitionOut={onCollapse}
    className={className}>
    {children}
  </Transition>
)

export default Slide

Slide.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  duration: PropTypes.number,
  inline: PropTypes.bool,
  on: PropTypes.bool,
  preserveElement: PropTypes.bool,
  onCollapse: PropTypes.func,
  onExpand: PropTypes.func,
  slideDown: PropTypes.number,
  slideUp: PropTypes.number,
  style: PropTypes.object,
}
